import classNames from 'classnames';

import { LiveQuizLeaderboardEntry } from '../../../types/index.ts';

interface PodiumProps {
    entries: LiveQuizLeaderboardEntry[];
    highlightParticipantId?: string | null;
}

const podiumOrder = [1, 0, 2];

const podiumStyles = [
    { height: 'h-32', accent: 'bg-amber-400 dark:bg-amber-500', label: '1st' },
    { height: 'h-24', accent: 'bg-slate-300 dark:bg-slate-500', label: '2nd' },
    { height: 'h-16', accent: 'bg-orange-300 dark:bg-orange-700', label: '3rd' },
];

const Podium: React.FC<PodiumProps> = ({ entries, highlightParticipantId }) => {
    const topThree = entries.slice(0, 3);
    if (topThree.length === 0) {
        return null;
    }

    return (
        <div className="flex items-end justify-center gap-3 sm:gap-6">
            {podiumOrder
                .filter((index) => topThree[index])
                .map((index) => {
                    const entry = topThree[index];
                    const style = podiumStyles[index];
                    const isMe = entry.participantId === highlightParticipantId;

                    return (
                        <div key={entry.participantId} className="flex flex-col items-center w-24 sm:w-32">
                            <div
                                className={classNames('max-w-full text-center mb-2', {
                                    'font-bold text-slate-900 dark:text-white': isMe,
                                    'font-medium text-slate-700 dark:text-slate-300': !isMe,
                                })}
                            >
                                <div className="truncate text-sm">{entry.name}</div>
                                <div className="text-lg font-bold tabular-nums text-slate-900 dark:text-white">{entry.score}</div>
                            </div>
                            <div
                                className={classNames(
                                    'w-full rounded-t-md grid place-items-center text-sm font-bold text-slate-900/70 dark:text-white/80',
                                    style.height,
                                    style.accent,
                                    { 'ring-2 ring-teal-500 ring-offset-2 ring-offset-white dark:ring-offset-slate-900': isMe },
                                )}
                            >
                                {style.label}
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};

export default Podium;
